import { useBuyersProfileQuery } from 'generated/graphql';
import useUser from './useUser';

const useBuyersProfile = () => {
  const { isAdmin, isSeller, user } = useUser();

  const [result] = useBuyersProfileQuery({
    variables: { profileID: String(user?.profileId) },
    pause: isSeller || isAdmin || !user?.profileId,
  });

  if (result.error) {
    console.error('Error fetching buyers profile:', result.error);
  }

  return result.data?.buyersProfile;
};

export default useBuyersProfile;
